import BudgetPercentageFields from "./BudgetPercentageFields";
import BudgetServiceSelects from "./BudgetServiceSelects";
import RemoveButton from "./RemoveButton";

interface IBudgetServiceFieldsProps {
  serviceId: string;
  failureModeId?: string;
  isExternalService?: boolean;
  volkstotalPercentage?: number;
  dealershipPercentage?: number;
  warrantyPercentage?: number;
  showPercentageFields?: boolean;
  onServiceChange?: (serviceId: string, serviceData?: any) => void;
  onFailureModeChange?: (failureModeId: string) => void;
  onVolkstotalPercentageChange?: (value: number) => void;
  onDealershipPercentageChange?: (value: number) => void;
  onWarrantyPercentageChange?: (value: number) => void;
  onRemoveService?: () => void;
}

const BudgetServiceFields = ({
  serviceId,
  failureModeId,
  isExternalService,
  volkstotalPercentage,
  dealershipPercentage,
  warrantyPercentage,
  showPercentageFields,
  onServiceChange,
  onFailureModeChange,
  onVolkstotalPercentageChange,
  onDealershipPercentageChange,
  onWarrantyPercentageChange,
  onRemoveService,
}: IBudgetServiceFieldsProps) => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 w-full items-start">
      <div className="flex flex-col lg:flex-row gap-4 items-start flex-1 min-w-0 flex-wrap">
        {!isExternalService && (
          <div className="flex w-full lg:w-auto flex-shrink-0 mb-4">
            <BudgetServiceSelects
              serviceId={serviceId}
              failureModeId={failureModeId}
              onChangeItem={(itemId, serviceData) =>
                onServiceChange?.(itemId, serviceData)
              }
              onChangeModoFalha={(modoFalhaId) =>
                onFailureModeChange?.(modoFalhaId)
              }
            />
          </div>
        )}
        <BudgetPercentageFields
          volkstotalPercentage={volkstotalPercentage}
          dealershipPercentage={dealershipPercentage}
          warrantyPercentage={warrantyPercentage}
          showPercentageFields={showPercentageFields}
          onVolkstotalPercentageChange={onVolkstotalPercentageChange}
          onDealershipPercentageChange={onDealershipPercentageChange}
          onWarrantyPercentageChange={onWarrantyPercentageChange}
        />
      </div>
      {onRemoveService && (
        <div className="flex items-center flex-shrink-0 self-start ml-auto lg:ml-0">
          <RemoveButton label="Remover serviço" onClick={onRemoveService} />
        </div>
      )}
    </div>
  );
};

export default BudgetServiceFields;
